import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { buildDynamicLinkForRef, constructArtificialLinkNode } from "../../../utils/links";
import { getProductPrices } from "./utils";
import Rating from "./sub-components/ProductRating";
import Image from "../image/Image";
import LinkWrapper from "../linkWrapper/LinkWrapper";

const ProductTeaserWrap = ({ product, currency, addToCart, addToWishlist, addToCompare, cartItem, wishlistItem, compareItem }) => {
    const productLinkNode = constructArtificialLinkNode({ value: buildDynamicLinkForRef("PRODUCT_DETAIL", product) });
    const { discountedPrice, finalProductPrice, finalDiscountedPrice } = getProductPrices(
        product.price,
        product.discount,
        currency.currencyRate,
    );

    return (
        <div className="shop-list-wrap">
            <div className="row">
                {product.image && product.image.length > 0 && (
                    <div className="col-xl-4 col-md-5 col-sm-6">
                        <div className="product-list-image-wrap">
                            <div className="product-img">
                                <LinkWrapper linkNode={productLinkNode}>
                                    <Image imageNode={product.image[0]} className="default-img img-fluid" />
                                    {product.image.length > 1 && <Image imageNode={product.image[1]} className="hover-img img-fluid" />}
                                </LinkWrapper>

                                {(product.discount || product.new) && (
                                    <div className="product-img-badges">
                                        {product.discount ? <span className="pink">-{product.discount}%</span> : ""}
                                        {product.new ? <span className="purple">New</span> : ""}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                <div className="col-xl-8 col-md-7 col-sm-6">
                    <div className="shop-list-content">
                        <h3>
                            <LinkWrapper linkNode={productLinkNode}>{product.displayName}</LinkWrapper>
                        </h3>
                        <div className="product-list-price">
                            {discountedPrice !== null ? (
                                <Fragment>
                                    <span>{currency.currencySymbol + finalDiscountedPrice}</span>{" "}
                                    <span className="old">{currency.currencySymbol + finalProductPrice}</span>
                                </Fragment>
                            ) : (
                                <span>{currency.currencySymbol + finalProductPrice} </span>
                            )}
                        </div>
                        {product.rating && product.rating > 0 ? (
                            <div className="rating-review">
                                <div className="product-list-rating">
                                    <Rating ratingValue={product.rating} />
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {product.shortDescription ? <p>{product.shortDescription}</p> : ""}

                        <div className="shop-list-actions d-flex align-items-center">
                            <div className="shop-list-btn btn-hover">
                                {product.affiliateLink ? (
                                    <a href={product.affiliateLink} rel="noopener noreferrer" target="_blank">
                                        {" "}
                                        Buy now{" "}
                                    </a>
                                ) : product.variation && product.variation["@nodes"].length >= 1 ? (
                                    <LinkWrapper linkNode={productLinkNode}>Select Option</LinkWrapper>
                                ) : product.stock && product.stock > 0 ? (
                                    <button
                                        onClick={() => addToCart(product)}
                                        className={cartItem !== undefined && cartItem.quantity > 0 ? "active" : ""}
                                        disabled={cartItem !== undefined && cartItem.quantity > 0}
                                        title={cartItem !== undefined ? "Added to cart" : "Add to cart"}
                                    >
                                        {" "}
                                        <i className="pe-7s-cart"></i>{" "}
                                        {cartItem !== undefined && cartItem.quantity > 0 ? "Added" : "Add to cart"}
                                    </button>
                                ) : (
                                    <button disabled className="active">
                                        Out of Stock
                                    </button>
                                )}
                            </div>

                            <div className="shop-list-wishlist ml-10">
                                <button
                                    className={wishlistItem !== undefined ? "active" : ""}
                                    disabled={wishlistItem !== undefined}
                                    title={wishlistItem !== undefined ? "Added to wishlist" : "Add to wishlist"}
                                    onClick={() => addToWishlist(product)}
                                >
                                    <i className="pe-7s-like" />
                                </button>
                            </div>
                            <div className="shop-list-compare ml-10">
                                <button
                                    className={compareItem !== undefined ? "active" : ""}
                                    disabled={compareItem !== undefined}
                                    title={compareItem !== undefined ? "Added to compare" : "Add to compare"}
                                    onClick={() => addToCompare(product)}
                                >
                                    <i className="pe-7s-shuffle" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ProductTeaserWrap.propTypes = {
    addToCart: PropTypes.func,
    addToCompare: PropTypes.func,
    addToWishlist: PropTypes.func,
    cartItem: PropTypes.object,
    compareItem: PropTypes.object,
    currency: PropTypes.object,
    product: PropTypes.object,
    wishlistItem: PropTypes.object,
};

export default ProductTeaserWrap;
